import { SelectInput } from '@core/components/Select';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { ExpansionPanelDetails, Grid, Typography } from '@material-ui/core';
import { ConfiguracaoContext } from 'app/main/configuracao/ConfiguracaoContext';
import React, { useContext, useMemo } from 'react';
import { CategoriaContext } from '../../CategoriaContext';
import vinculoStyles from './styles';

const VinculosAutomaticos = ({ onChangeVinculoAutomatico }) => {
  const styles = vinculoStyles();

  const [vinculosAutomaticos] = useContext(CategoriaContext).vinculosAutomaticos;
  const [classesAnaliticoSintetico] = useContext(CategoriaContext).classesAnaliticoSintetico;
  const [readOnly] = useContext(ConfiguracaoContext).categoriaReadOnly;

  const Header = ({ nome, column1, column2, className }) => (
    <Grid container className={className}>
      <Typography className={styles.titleBold} variant="button">
        {nome}
      </Typography>
      <Grid container>
        <Grid item className={styles.content} md={4} sm={4} xs={4}>
          <Typography className={styles.subtitleBold} variant="subtitle1">
            {column1}
          </Typography>
        </Grid>
        <Grid item md={8} sm={8} xs={8}>
          <Typography className={styles.subtitleBold} variant="subtitle1">
            {column2}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  const Linha = ({ nome, classes, chave, onChange = () => {} }) => {
    return (
      <>
        <Grid item className={styles.line} md={4} sm={4} xs={4}>
          <Typography className={styles.subtitle} variant="subtitle1">
            {nome}
          </Typography>
        </Grid>
        <Grid item md={8} sm={8} xs={8} className={styles.vinculoContainer}>
          {/* De acordo com a Keila só é necessário ter a permissão de editar */}
          {permissaoUtils.categoria().editar && !readOnly ? (
            <SelectInput
              label="Categoria"
              value={vinculosAutomaticos[chave] && vinculosAutomaticos[chave].classeId}
              readOnly={readOnly}
              fullWidth
              onChange={(e) => {
                const [classe = {}] = classes.filter((c) => !!c).filter((c) => c.id === e.target.id);
                onChange(chave, e.target.value);
                onChangeVinculoAutomatico(
                  vinculosAutomaticos,
                  {
                    id: vinculosAutomaticos[chave] && vinculosAutomaticos[chave].id,
                    classeId: e.target.value,
                    processo: chave.replace('RECEITA_', '').replace('DESPESA_', ''),
                    classeNome: classe.nome,
                    natureza: classe.natureza,
                  },
                  chave
                );
              }}
              options={classes
                .filter((classe) => !!classe)
                .map((classe) => ({ id: classe.id, title: `${classe.indice} ${classe.nome}` }))}
            />
          ) : (
            <Typography className={styles.subtitle}>
              {vinculosAutomaticos[chave]
                ? vinculosAutomaticos[chave].indice !== undefined
                  ? `${vinculosAutomaticos[chave].indice} ${vinculosAutomaticos[chave].classeNome}`
                  : 'Carregando...'
                : '-'}
            </Typography>
          )}
        </Grid>
      </>
    );
  };

  return useMemo(
    () => (
      <ExpansionPanelDetails>
        <Grid className={styles.container} container spacing={4}>
          <Grid item md={6} sm={12}>
            <Header nome="1. RECEITAS" column1="Processos" column2="Categoria para lançamento automático" />
            <Grid container>
              <Linha
                id="receita-correcao"
                chave="RECEITA_CORRECAO_MONETARIA"
                nome="Correção monetária"
                classes={classesAnaliticoSintetico.receita.analitico}
              />
              <Linha
                id="receita-desconto"
                chave="RECEITA_DESCONTO"
                nome="Desconto"
                classes={classesAnaliticoSintetico.receita.analitico}
              />
              <Linha
                id="receita-juros"
                chave="RECEITA_JUROS"
                nome="Juros"
                classes={classesAnaliticoSintetico.receita.analitico}
              />
              <Linha
                id="receita-multa"
                chave="RECEITA_MULTA"
                nome="Multa"
                classes={classesAnaliticoSintetico.receita.analitico}
              />
            </Grid>
          </Grid>
          <Grid item className={styles.divider} md={6} sm={12}>
            <Header nome="2. DESPESAS" column1="Processos" column2="Categoria para lançamento automático" />
            <Grid container>
              <Linha
                id="despesa-desconto"
                chave="DESPESA_DESCONTO"
                nome="Desconto"
                classes={classesAnaliticoSintetico.despesa.analitico}
              />
              <Linha
                id="despesa-juros"
                chave="DESPESA_JUROS"
                nome="Juros"
                classes={classesAnaliticoSintetico.despesa.analitico}
              />
              <Linha
                id="despesa-multa"
                chave="DESPESA_MULTA"
                nome="Multa"
                classes={classesAnaliticoSintetico.despesa.analitico}
              />
              <Linha
                id="despesa-parterbank"
                chave="DESPESA_PARTNER_BANK"
                nome="Partner Bank"
                classes={classesAnaliticoSintetico.despesa.analitico}
              />
            </Grid>
          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    ),
    // Memoização intencional: as funções são recriadas a cada render e incluí-las anularia o memo;
    // o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vinculosAutomaticos, classesAnaliticoSintetico, readOnly, styles.container, styles.divider]
  );
};

export default VinculosAutomaticos;
